export default __webpack_public_path__ + "static/media/sostenibilita-wallpaper.e3f6e3e9.jpg";